import React from "react";
import { Form } from "react-bootstrap";
import { Field } from "../../component";

const TextField = props => {
  const {
    label,
    isRequiredField,
    placeholder,
    formData,
    onChange,
    name,
    showRequiredError,
    onBlur = value => {}
  } = props;
  return (
    <Form.Group
      className={`${showRequiredError && formData === "" ? "mt-3" : ""}`}
    >
      <Form.Label>
        {label} {isRequiredField ? <span className="required">*</span> : <></>}
      </Form.Label>
      <div className="form-field">
        <Field
          className={`${
            showRequiredError && formData === "" ? "is-invalid" : ""
          }`}
          type="text"
          placeholder={placeholder}
          onChange={event => onChange(event, name)}
          value={formData}
          name={name}
          onBlur={onBlur}
        />
      </div>
    </Form.Group>
  );
};

export default TextField;
